export default "__VITE_ASSET__QV_EOoSD__"